import React from 'react';
import PropTypes from 'prop-types';

import { motion } from 'framer-motion';

import {
    Check,
    bannerAnimation,
    bannerTransition,
    determineBannerMessage,
} from './constants';

import './SuccessBanner.scss';

const SuccessBanner = ({ type }) => {
    if (type === 'none') return null;

    const message = determineBannerMessage(type);

    return (
        <motion.div
            className="component-UnifiedPostCard-SuccessBanner"
            transition={bannerTransition}
            animate={bannerAnimation}
        >
            <span className="banner-check-icon">
                <Check />
            </span>
            <span className="banner-message">{message}</span>
        </motion.div>
    );
};

SuccessBanner.propTypes = {
    type: PropTypes.oneOf(['new', 'edit', 'none']),
};

SuccessBanner.defaultProps = {
    type: 'none',
};

SuccessBanner.displayName = 'SuccessBanner';

export default SuccessBanner;
